<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="col-1"
          style="min-width: 250px; max-width: 250px"
        ></select-project>

        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="col-1"
          style="min-width: 250px; max-width: 250px"
        ></v-select>
        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 150px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 150px"
        />

        <v-btn color="info" v-on:click="search(true)" class="mt-3" :disabled="loading" :loading="loading">Search</v-btn>
      </v-row>
    </v-card>


    <v-card class="pa-0 mt-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        sort-by="created"
        sort-desc
        item-key="account_transaction_id"
        :server-items-length="total"
        :options.sync="options"
        :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
        :items-per-page="25"
        :class="{nowrap: true, 'payment-handler-dt': true, 'footer-padding': $store.state.auth.checkAccess({key: 'kiosk.access', value: true})}"
        style="z-index: 0; position: relative;"
      >
        <template v-slot:body.prepend>
          <tr class="grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
              style="border: none"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="columnValueList(header.value)"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </template>

        <template v-slot:item.comment="{ item }">
          <div style="min-width: 250px;">
            <v-textarea
              v-model="item.comment"
              small
              auto-grow
              rows="1"
              hide-details
              append-icon="mdi-content-save"
              @click:append="updateTransaction(item)"
              class="col-12 payment-handler-update-comment pa-0"
            ></v-textarea>
          </div>
        </template>
        <template v-slot:item.external_id="{ item }">
          <v-text-field
            v-model="item.external_id"
            small
            hide-details
            prefix="#"
            style="width: 100px; font-size: 14px"
            class="ma-0 pa-0"
          ></v-text-field>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<style lang="scss" scoped>
  @import './payment-table.scss';
</style>

<script>
  import moment from 'moment'
  import { set, map, get, cloneDeep, find } from 'lodash'
  import { API } from '@/utils/api'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: { SelectProject, DatePicker },

    props: { title: {} },
    data: () => ({
      url: '/$v/payment_handler/list.json',
      headers: [
        { text: 'Created', value: 'created' },
        { text: 'Completed', value: 'completed' },
        { text: 'Account ID', value: 'account_id', sortable: true },
        { text: 'Login', value: 'login', sortable: true },
        { text: 'Transaction ID', value: 'account_transaction_id', sortable: true },
        { text: 'External ID', value: 'external_id', sortable: true },
        { text: 'Amount', value: 'amount', sortable: true },
        { text: 'Currency', value: 'currency', sortable: true },
        { text: 'Amount EUR', value: 'amount_eur', sortable: false },
        { text: 'Paymethod', value: 'paymethod', sortable: false },
        { text: 'Paysystem', value: 'paysystem', sortable: false },
        { text: 'Account', value: 'account', sortable: false },
        { text: 'Comment', value: 'comment', sortable: false },
      ],
      filters: {
        account_id: { data: [], type: 'text' },
        account_transaction_id: { data: [], type: 'text' },
        currency: { data: [], type: 'select' },
        paymethod: { data: [], type: 'select' },
        paysystem: { data: [], type: 'select' },
        status: { data: [ 'complete', 'pending' ], type: 'select' },
        exclude_paysystem: { data: [ 1, 'internal' ], type: 'select' },
      },
      project: null,
      loading: false,
      items: [],
      options: {},
      total: 0,
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      dateRangeList,
    }),

    computed: {
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            return !d[f] || this.filters[f].data.length < 1 || (this.filters[f].data.includes(d[f]) || (typeof d[f] == 'number' ? d[f].toString() : d[f]).indexOf(this.filters[f].data) >= 0)
          })
        })
      },
    },

    mounted () {
      this.loadEntities()
    },

    watch: {
      options: {
        handler () {
          this.search(false)
        },
      }
    },

    methods: {
      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

      updateTransaction: async function (item) {

        if (await this.$root.$confirm('Confirm', 'Do you want save changes?')) {

          API.call('/$v/payment_handler/update.json', {
            account_transaction_id: item.account_transaction_id,
            comment: item.comment,
            fields: { external_id: item.external_id || '' },
          }, null, this.project).then(resp => {

            if (resp.data.external_id == item.external_id && resp.data.comment == item.comment) {
              set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', item.comment)
              set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'external_id', item.external_id)
            } else {

              this.$nextTick(function () {
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment', resp.data['comment'])
                item.comment = resp.data.comment
                set(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'external_id', resp.data['external_id'])
                item.external_id = resp.data.external_id
              })

            }
            return resp.data
          }).catch(e => {
            this.search()
          })
        } else {
          this.$nextTick(function () {
            item.comment = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'comment')
            item.external_id = get(find(this.itemsInit, { account_transaction_id: item.account_transaction_id }), 'external_id')
          })
        }
      },

      search: function (resetPage) {
        if (resetPage === true) {
          this.options.page = 1
        }
        this.loading = true

        try {
          API.call(this.url, {
            from: this.from,
            to: this.to,
            type: 'withdraw',
            // filters: { status: [ 'complete', 'pending' ] },
            options: this.options,
            filters: _.reduce(this.filters, (r, f, k) => {
              if (!_.isEmpty(f.data)) {
                r[k] = f.data
              }
              return r
            }, {}),
            limit: 50
          }, null, this.project).then(resp => {

            this.total = resp.total
            this.items = cloneDeep(resp.data)
            this.itemsInit = cloneDeep(resp.data)

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      loadEntities () {
        return API.call('/users/entity_list.json').then(resp => {
          this.entities = resp.data
          return resp.data
        }).catch(e => {
        })
      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        return this.items.map(d => d[val])
      }
    },
  }
</script>
